"use strict";
/**
 * Font Awesome conditional loading
 * Only loads the icon variants that are actually used on the page
 *
 * @package StandOut
 * @since 2.0.0
 */
document.addEventListener("DOMContentLoaded", () => {
    const fontawesome = document.querySelectorAll("[class*='fa-']");
    const hasButtons = document.querySelector(".button__icon") !== null;
    if (fontawesome.length > 0 || hasButtons) {
        // The variant files only hold @font-face; the icon name → glyph map lives in the core file.
        const variants = [
            import("../../css/libraries/fontawesome/fontawesome.css"),
            import("@fortawesome/fontawesome-pro/css/fontawesome.min.css"),
        ];
        if (document.querySelector("[class*='fa-solid']")) {
            variants.push(import("@fortawesome/fontawesome-pro/css/solid.min.css"));
        }
        if (document.querySelector("[class*='fa-regular']")) {
            variants.push(import("@fortawesome/fontawesome-pro/css/regular.min.css"));
        }
        if (document.querySelector("[class*='fa-light']") || hasButtons) {
            variants.push(import("@fortawesome/fontawesome-pro/css/light.min.css"));
        }
        if (document.querySelector("[class*='fa-duotone']")) {
            variants.push(import("@fortawesome/fontawesome-pro/css/duotone.min.css"));
        }
        if (document.querySelector("[class*='fa-thin']")) {
            variants.push(import("@fortawesome/fontawesome-pro/css/thin.min.css"));
        }
        if (document.querySelector("[class*='fa-brands']")) {
            variants.push(import("@fortawesome/fontawesome-pro/css/brands.min.css"));
        }
        if (document.querySelector("[class*='fa-sharp']")) {
            variants.push(import("@fortawesome/fontawesome-pro/css/sharp-solid.min.css"));
        }
        Promise.all(variants).catch((error) => {
            console.error("Failed to load Font Awesome:", error);
        });
    }
});
